import React from 'react';
import Navigation from '../navigation';

const RatingContainer: React.FC = () => {
    return (
      <div className='page-layout'>
        <Navigation/>
        <main className='main'>
          <div>Rating</div>
        </main>
      </div>
    );
  };
  
export default RatingContainer;